<template>
  <div class="player margin-between-section">
    <div class="row not-margin">
      <div class="col-md-12 container-info">
        <h1>Home Slideshow</h1>
        <!--<router-link to="/admin">
          <img src="../assets/images/back.png" /> Regresar
        </router-link>-->
      </div>
    </div>
    <div class="row not-margin">
      <div class="col-md-12 col-lg-6 info-form-contact margin-between-section">
        <div class="margin-between-section">
          <div class="group">
            <input v-model="title1" class="input-form" type="text" :placeholder="$t('admin.slideshow.title1')" />
          </div>
          <div class="group">
            <input v-model="description1" class="input-form" type="text" :placeholder="$t('admin.slideshow.description1')" />
          </div>
          <div class="group">
            <div v-if="fileOpen1 == 1">
              <div class="file-field">
                <label for="uplimage"><img src="../assets/images/image.png" />{{ $t('admin.slideshow.add_image1')}}</label>
                <input @change="processFile($event)" id="uplimage" class="uplimage" type="file" accept="image/*">
              </div>
            </div>
            <div v-bind:class="{'dnone': fileOpen1 == 1}">
              <div class="in-f-ima">
                <label class="">{{file1}}</label>
                <button class="closeH" v-on:click="openImg(1)">X</button>
              </div>
            </div>
          </div>
        </div>
        <div class="margin-between-section m-top-slide">
            <div class="group">
              <input  v-model="title2" class="input-form" type="text" :placeholder="$t('admin.slideshow.title2')" />
          </div>
          <div class="group">
            <input v-model="description2"  class="input-form" type="text" :placeholder="$t('admin.slideshow.description2')" />
          </div>
          <div class="group">
            <div v-if="fileOpen2 == 2">
              <div class="file-field">
                <label for="uplimage2"><img src="../assets/images/image.png" />{{ $t('admin.slideshow.add_image2')}}</label>
                <input @change="processFile2($event)" id="uplimage2" class="uplimage2" type="file" accept="image/*">
              </div>
            </div>
            <div v-bind:class="{'dnone': fileOpen2 == 2}">
              <div class="in-f-ima">
                <label class="">{{file2}}</label>
                <button class="closeH" v-on:click="openImg1(2)">X</button>
              </div>
            </div>
          </div>
        </div>
        <div class="margin-between-section  m-top-slide">
          <div class="group">
            <input v-model="title3" class="input-form" type="text" :placeholder="$t('admin.slideshow.title3')" />
          </div>
          <div class="group">
            <input v-model="description3" class="input-form" type="text" :placeholder="$t('admin.slideshow.description3')" />
          </div>
          <div class="group">
            <div v-if="fileOpen3 == 3">
              <div class="file-field">
                <label for="uplimage3"><img src="../assets/images/image.png" />{{ $t('admin.slideshow.add_image3')}}</label>
                <input @change="processFile3($event)" id="uplimage3" class="uplimage3" type="file" accept="image/*">
              </div>
            </div>
            <div v-bind:class="{'dnone': fileOpen3 == 3}">
              <div class="in-f-ima">
                <label class="">{{file3}}</label>
                <button class="closeH" v-on:click="openImg2(3)">X</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 info-form-contact margin-between-section img-sf">
        <div class="margin-between-section">
          <img v-bind:class="{'dnone': fileOpen1 == 1}" :src="file1">
        </div>
        <div class="margin-between-section ">
          <img v-bind:class="{'dnone': fileOpen2 == 2}" class="m-top-img" :src="file2">
        </div>
        <div class="margin-between-section ">
          <img v-bind:class="{'dnone': fileOpen3 == 3}" class="m-top-img" :src="file3">
        </div>
        
      </div>
      <p class="error" v-if="error != ''" >* {{error}}</p>
    </div>
    <div class="col-md-12 margin-between-section text-left">
      <button v-on:click="saveSlide" type="btn" class="btn btn-action">{{ $t('admin.slideshow.save') }}</button>
    </div>
  </div>
</template>

<script>

import SlideShow from '@/parse/models/SlideShow';
import { bus } from '../main'

export default {
  name: "player",
  components: {},
  data() {
    return {
      data: [],
      id1: "",
      title1: "",
      description1: "",
      file1: null,
      id2: "",
      title2: "",
      description2: "",
      file2: null,
      id3: "",
      title3: "",
      description3: "",
      file3: null,
      error: "",
      fileOpen1: 0,
      fileOpen2: 0,
      fileOpen3: 0
    };
  },
  beforeMount() {
    SlideShow.load().then(info => {
      
      this.id1 = info[0].id
      this.title1 = info[0].title
      this.description1 = info[0].description
      this.file1 = info[0].cover
      
      if(this.file1 == ''){this.fileOpen == 1}
      
      this.id2 = info[1].id
      this.title2 = info[1].title
      this.description2 = info[1].description
      this.file2 = info[1].cover

      if(this.file2 == ''){this.fileOpen == 2}

      this.id3= info[2].id
      this.title3 = info[2].title
      this.description3 = info[2].description
      this.file3 = info[2].cover

      if(this.file3 == ''){this.fileOpen == 3}
      
    })
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    processFile(){
      this.file1 = event.target.files[0]
    },
    processFile2(){
      this.file2 = event.target.files[0]
    },
    processFile3(){
      this.file3 = event.target.files[0]
    },
    saveSlide(){
        
      const notification = {
        disable: false,
        sampleMessage: true,
        message: this.$t('admin.load_player_reel'),
        progressive: true
      }

      bus.$emit('sample', notification)

      if (this.title1 == ""){
        this.error = this.$t('notification.required')
        return
      }

      if (this.description1 == ""){
        
        this.error = this.$t('notification.required')
        return
      }


      if (this.title2 == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.description2 == ""){
        
        this.error = this.$t('notification.required')
        return
      }
      
      if (this.title3 == ""){
        this.error = this.$t('notification.required')
        return
      }
      if (this.description3 == ""){
        
        this.error = this.$t('notification.required')
      }



      this.error = ""
      //const info = []

      const params = {
        info: [
            {
              id: this.id1,
              title: this.title1,
              description: this.description1,
              file: this.file1
            },
            {
            
              id: this.id2,
              title: this.title2,
              description: this.description2,
              file: this.file2
            },
            {
            
              id: this.id3,
              title: this.title3,
              description: this.description3,
              file: this.file3
            },
        ]      
      }

      for(let i = 0; i < 3; i++ ){

        SlideShow.saveSlide(params.info[i])
        .then((user) => console.log(user))
        .catch(error => console.log(error))
        3000
        
        if(i == 2){
          this.notification = {
            percentage: 100,
          }
          setTimeout(() => bus.$emit('progressiveBar', this.notification), 3000);  
          setTimeout(() => (bus.$emit('close', "arg")), 8000);  
          setTimeout(() => (this.notify()), 8000);  
        } else {
          
          const value = (i+1) * 30

          this.notification = {
            percentage: 30
          }
          setTimeout(() => bus.$emit('progressiveBar', this.notification), 1000);  
        }
      }
    },
    openImg(val){
      this.fileOpen1 = val
    },
    openImg1(val){
      this.fileOpen2 = val
    },
    openImg2(val){
      this.fileOpen3 = val
    },

    notify(){
      const notification = {
        disable: false,
        sampleMessage: true,
        message: this.$t('admin.slideshow.update')
      }

      bus.$emit('sample', notification)

      SlideShow.load().then(info => {
        
        this.id1 = info[0].id
        this.title1 = info[0].title
        this.description1 = info[0].description
        this.file1 = info[0].cover
        
        if(this.file1 == ''){this.fileOpen == 1}
        
        this.id2 = info[1].id
        this.title2 = info[1].title
        this.description2 = info[1].description
        this.file2 = info[1].cover

        if(this.file2 == ''){this.fileOpen == 2}

        this.id3= info[2].id
        this.title3 = info[2].title
        this.description3 = info[2].description
        this.file3 = info[2].cover

        if(this.file3 == ''){this.fileOpen == 3}
      
      })

      this.fileOpen1 = 0,
      this.fileOpen2 = 0,
      this.fileOpen3 = 0
    }
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.dnone{
  display: none;
}

.closeH{
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  padding: 0;
  margin: 0;
  border: 1px solid #000;
  border-radius: 20px;
  width: 20px;
  height: 20px;
  margin-right: -10px;
  margin-top: -10px;
}

.in-f-ima{
  position: relative;
  width: 80%;
}

.in-f-ima label{
  border: 1px solid #000;
  padding: 10px;
  width: 100%;
  overflow: hidden;
}

.m-top-slide{
  margin-top: 5%;
}

.lb-position{
  position: absolute;
  width: 91.5px;
  height: 50px;
  left: 11px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
}

.cb-position{
  position: absolute;
  width: 91px;
  height: 153px;
  left: 11px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
}

.rb-position{
  position: absolute;
  width: 91.5px;
  height: 50px;
  left: 11px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
}

.lwb-position{
  position: absolute;
  width: 91.5px;
  height: 50px;
  left: 101px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
}

.rwb-position{
  position: absolute;
  width: 91.5px;
  height: 50px;
  left: 102px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
}

.dm-position{
  position: absolute;
  width: 50px;
  height: 153px;
  left: 102px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
}

.lm-position{
  position: absolute;
  width: 183px;
  height: 50px;
  left: 195px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
}

.cm-position{
  position: absolute;
  width: 93px;
  height: 153px;
  left: 152px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
}

.rm-position{
  position: absolute;
  width: 183px;
  height: 50px;
  left: 195px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
}

.am-position{
  position: absolute;
  width: 50px;
  height: 153px;
  left: 245px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
}

.s-position{
  position: absolute;
  width: 83px;
  height: 153px;
  left: 295px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
}

.map-area-container{
  background-color: #fff;
  width: 400px;
  height: 250px;
  position: relative;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
}

.map-area{
  background: url('../assets/images/camp.png') 100% 100% no-repeat;
  width: 389px;
  height: 253px;
  position: relative;
}


.btn {
  font-size: 12px;
}

.btn-action {
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
  border-radius: 0;
}

ul {
  text-decoration: none;
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  display: inline;
}

.btn-position {
  font-size: 10px;
  border-bottom: 1px solid #000;
  width: 25px;
  padding: 0;
  margin-right: 5px;
  text-transform: uppercase;
  font-family: "plain medium", arial;
}

.margin-zero {
  margin: 0;
}
.padding-zero {
  padding: 0;
}

.c-header {
  width: 100%;
}

.info {
  text-align: left;
  width: 100%;
}

.info h1 {
  font-size: 20px;
  font-family: "plain regular", arial;
  display: inline-block;
  font-weight: bold;
}

.container-age {
  display: inline-block;
  margin: 35px;
}

.info h1 img {
  width: 20px;
  margin-right: 10px;
  margin-top: -8px;
}

.info p {
  font-size: 18px;
}

.container-info {
  font-family: "plain regular", arial;
}

.container-info h1 {
  font-weight: 600;
  font-family: "plain regular", arial;
  float: left;
  font-size: 18px;
}

.container-info a {
  color: #000;
  font-family: "plain regular", arial;
  float: right;
  margin-right: 5px;
}

.container-info a img {
  width: 20px;
}

.not-margin {
  margin: 0;
}

.not-padding {
  padding: 0;
}

.group {
  margin-top: 3.5%;
}

.info-form-contact {
  text-align: left;
  font-size: 13px;
}

.info-form-contact label {
  margin-bottom: 0;
  font-size: 13px;
  width: 100%;
  overflow: hidden;
}

.input-form {
  border: 0;
  border-bottom: 1px solid #000;
  width: 80%;
}

.con-i input {
  border: 0;
  border-bottom: 1px solid #000;
  width: 120px;
  font-size: 12px;
  margin-left: 5%;
}

.send-b {
  border: 1px solid #000;
  border-radius: 0;
  margin-left: 0px;
  font-size: 12px;
  padding: 5px 30px;
  margin-bottom: 9px;
}

.container-drop {
  float: right;
}

.dropdown {
  display: inline-block;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  margin-right: 5px;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
}

.dropdown-menu {
  border: 1px solid #000;
  border-radius: 0;
  margin: 0.125rem -1px 0;
}

.dropdown-toggle::after {
  margin-left: 5em;
}

.dropdown-btn {
  font-size: 13px;
}

.dropdown-item {
  font-size: 13px;
}

.instruction {
  color: #000;
  font-size: 11px !important;
  font-family: "plain regular", arial;
}

.instruction-position {
  color: rgb(138, 138, 138);
  font-size: 9px !important;
}

.camp-position {
  position: relative;
  display: inline-block;
}

.container-footer-drop {
  position: relative;
  margin: 35px;
}

.container-footer-drop img {
  width: 50%;
  margin-bottom: 5px;
}

.instruction-mapa {
  color: rgb(124, 124, 124);
  font-size: 9px !important;
  margin-left: 10px;
}

#uplimage {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

label[for="uplimage"] {
  font-weight: 600;
  color: #000;
  border: 1px solid #000;
  background-color: #fff;
  display: inline-block;
  transition: all .5s;
  cursor: pointer;
  padding: 5px 40px !important;
  width: fit-content;
  text-align: center;
}

label[for="uplimage"] img{
  width: 18px;
  margin-right: 10px;
}


#uplimage2 {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

label[for="uplimage2"] {
  font-weight: 600;
  color: #000;
  border: 1px solid #000;
  background-color: #fff;
  display: inline-block;
  transition: all .5s;
  cursor: pointer;
  padding: 5px 40px !important;
  width: fit-content;
  text-align: center;
}

label[for="uplimage2"] img{
  width: 18px;
  margin-right: 10px;
}


#uplimage3 {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

label[for="uplimage3"] {
  font-weight: 600;
  color: #000;
  border: 1px solid #000;
  background-color: #fff;
  display: inline-block;
  transition: all .5s;
  cursor: pointer;
  padding: 5px 40px !important;
  width: fit-content;
  text-align: center;
}

label[for="uplimage3"] img{
  width: 18px;
  margin-right: 10px;
}


.img-sf img{
  width: 55%;
  float: right;
  
}

.m-top-img{
  margin-top: 5%;
}




/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {}

/* Larger than desktop */
@media (max-width: 992px) {
  .img-sf {
    display: none;
  }
  .input-form{
    width: 100%;
  }
  .in-f-ima{
    width: 100%;
  }
}

/* Larger than tablet */
@media (max-width: 768px) {
  
  .group {
    margin-top: 10%;
  }
}

/* Larger than phablet */
@media (max-width: 550px) {}

/* Larger than mobile */
@media (max-width: 400px) {}

</style>
